import { IFilter } from "@saleor/components/Filter";
import { FilterOpts, MinMax } from "@saleor/types";
import { createDateField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum CustomerActivityFilterKeys {
  lastLogin = "lastLogin",
  lastOrder = "lastOrder"
}

export interface CustomerActivityListFilterOpts {
  lastLogin: FilterOpts<MinMax>;
  lastOrder: FilterOpts<MinMax>;
}

const messages = defineMessages({
  lastLogin: {
    defaultMessage: "Last Login Date & Time",
    description: "customer"
  },
  lastOrder: {
    defaultMessage: "Last Purchase Date & Time",
    description: "customer"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: CustomerActivityListFilterOpts
): IFilter<CustomerActivityFilterKeys> {
  return [
    {
      ...createDateField(
        CustomerActivityFilterKeys.lastLogin,
        intl.formatMessage(messages.lastLogin),
        opts.lastLogin.value
      ),
      active: opts.lastLogin.active
    },
    {
      ...createDateField(
        CustomerActivityFilterKeys.lastOrder,
        intl.formatMessage(messages.lastOrder),
        opts.lastOrder.value
      ),
      active: opts.lastOrder.active
    }
  ];
}
